import * as yup from "yup";
export interface IChild {
  id?: string;
  firstName: string;
  lastName: string;
  gender: string;
  dateOfBirth: string;
  age: number;
  address: string;
  parentId: number;
  additionals: {
    ethnicity: string;
    religion: string;
    languages: string[];
  };
  photo?: string | File;
  classroomId: number;
  attendanceMode: number;
  classroom: Classroom;
  dietary?: IChildDietary | null;
}
export type Classroom = {
  id: number;
  name: string;
  description: string;
  rangeFrom: number;
  rangeTo: number;
};

export type MealType = "breakfast" | "snack" | "lunch" | "tea_time";
export type Season = "spring" | "summer" | "autumn" | "winter";

export const ALLERGENS = [
  "gluten",
  "dairy",
  "eggs",
  "peanuts",
  "nuts",
  "soy",
  "fish",
  "shellfish",
  "sesame",
] as const;
export type Allergen = (typeof ALLERGENS)[number];

export const SEVERITIES = ["mild", "moderate", "severe"] as const;
export type Severity = (typeof SEVERITIES)[number];

export interface IChildDietary {
  allergies?: string[];
  allergyOther?: string;
  severity?: string;
  preferences?: string;
  notes?: string;
  confirmedByNursery?: boolean;
  confirmedAt?: string | null;
  updatedBy?: string;
  updatedAt?: string;
}

export interface IMenuMeal {
  id?: number;
  dayOfWeek: number;
  mealType: MealType;
  description: string;
  dietaryDescription?: string;
}

export interface IMenuDay {
  id?: number;
  dayOfWeek: number;
  vegetarian: boolean;
  allergens: string[];
}

export interface IMenuWeek {
  id: number;
  nurseryId: number;
  year: number;
  season: Season;
  label: string;
  meals: IMenuMeal[];
  days: IMenuDay[];
}
export const columnsChildManage: ColumnProps[] = [
  { id: "firstName", label: "inputs.first_name", minWidth: 50 },
  { id: "lastName", label: "inputs.last_name", minWidth: 50 },
  { id: "gender", label: "inputs.gender", minWidth: 50 },
  { id: "parent", label: "inputs.parent", minWidth: 100 },
  { id: "dob", label: "inputs.birthday", minWidth: 50 },
  { id: "address", label: "labels.address", minWidth: 100 },
  { id: "action", label: "labels.action", minWidth: 50 },
];
export type BillData = {
  heading: string;
  ref: string;
  amount: string;
  currency: string;
  type: string;
  recieverId: string;
  id: number;
};
export interface Child {
  id: string;
  firstName: string;
  lastName: string;
  gender: string;
  dateOfBirth: string;
  address: string;
  additionals: {
    ethnicity: string;
    religion: string;
    languages: string[];
  };
  classroomId: number;
  parentId: number;
  photo?: string | File;
  fatherFirstName: string;
  fatherLastName: string;
  motherFirstName: string;
  motherLastName: string;
  thirdFirstName: string;
  thirdLastName: string;
  fatherEmail: string;
  motherEmail: string;
  thirdEmail: string;
  fatherMobile: string;
  motherMobile: string;
  thirdMobile: string;
  childId: number;
}

export interface ColumnProps {
  id: string;
  label: string;
  minWidth: number;
  align?: "right" | "left" | "inherit" | "center" | "justify" | undefined;
  format?: (value: Date | number) => string | boolean;
}

export interface FormFields {
  id: string;
  firstName: string;
  lastName: string;
  gender: string;
  dateOfBirth: string;
  address: string;
  additionals: {
    ethnicity: string;
    religion: string;
    languages: string[];
  };
  classroomId: number;
  parentId: number;
  attendanceMode?: number | string;
  photo?: string | File;
  fatherFirstName: string;
  motherFirstName: string;
  thirdFirstName: string;
  fatherLastName: string;
  motherLastName: string;
  thirdLastName: string;
  fatherEmail: string;
  motherEmail: string;
  thirdEmail: string;
  fatherMobile: string;
  motherMobile: string;
  thirdMobile: string;
  parent: {
    firstName: string;
    lastName: string;
    address: {
      line1: string;
      line2: string;
      city: string;
      country: string;
      postcode: string;
    };
  };
}

export type Parent = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  mobile: string;
  address: {
    line1: string;
    line2: string;
    city: string;
    country: string;
    postcode: string;
  };
  photo?: string | File;
  settignId: number;
  role: string;
  nurseryId: number;
};

export interface EvenDilogFormFields {
  child_voice: string;
  notes: string;
  nappy: string;
  from: string;
  to: string;
  duration: string;
  type: string;
  quantity: string;
}

export interface Props {
  open: boolean;
  onClose: () => void;
  child: IChild[];
  event: string;
}

export const validationSchema = yup.object({
  heading: yup.string().required("Title is required."),
  ref: yup.string().required("Content is required."),
  childId: yup.string().required("Child selection is required."),
  type: yup.string().required("Type selection is required."),
  currencyId: yup.string().required("Currency selection is required."),
  amount: yup.number().required("Amount selection is required."),
  id: yup.number(),
  status: yup.number(),
});
